import type { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import type { Boot } from 'portlet/config/boot';
import type { HttpService } from 'portlet/common/services';

export interface HierarchyVariant {
    key: string;
    text: string;
}

interface Response {
    Result: [Result, Message];
}

interface Result {
    name: 'ES_RESULT';
    kind: string;
    value: {
        io_name: string;
        hierarchy_table: HierarchyVariant[];
    };
}

interface Message {
    name: 'BROKER_MESSAGE';
    kind: string;
    value: [
        {
            msgty: string;
            msgid: string;
            msgno: string;
            msgv1: string;
            msgv2: string;
            msgv3: string;
            msgv4: string;
            text: string;
        },
    ];
}

export class HierarchyVariantsService {
    private bayerSapBWServerUrl = this.boot.servers.bayerSapBWServer.url;

    constructor(private readonly http: HttpService, private readonly boot: Boot) {}

    public getHierarchyVariants(dataSource: string): Observable<HierarchyVariant[]> {
        const hierarchyVariants = this.http
            .get<Response>(
                `${this.bayerSapBWServerUrl}/?APPLICATION=D1_INFOOBJECT&FUNCTION=GET_HIERARCHY&${dataSource}`,
                {
                    credentials: 'include',
                },
            )
            .pipe(map(({ data }) => data));

        return hierarchyVariants.pipe(map(res => res.Result[0].value.hierarchy_table));
    }
}
